import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
// 1. Import your logo file
import degchiLogo from '../assests/logo.png';

function Footer() {
  const [typedDescription, setTypedDescription] = useState('');
  const footerRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  // This effect will trigger the animation when the footer is scrolled into view
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target); // Animate only once
        }
      },
      { threshold: 0.1 }
    );

    if (footerRef.current) {
      observer.observe(footerRef.current);
    }

    return () => {
      if (footerRef.current) {
        observer.unobserve(footerRef.current);
      }
    };
  }, []);

  // This effect handles the typewriter animation itself
  useEffect(() => {
    if (isVisible) {
      const fullText = "Bringing the authentic taste of homemade Pakistani meals to your doorstep in Lahore.";
      let i = 0;
      setTypedDescription(''); // Reset on visible
      
      const timer = setInterval(() => {
        if (i < fullText.length) {
          setTypedDescription(prev => prev + fullText.charAt(i));
          i++;
        } else {
          clearInterval(timer);
        }
      }, 30); // Speed of typing in milliseconds

      return () => clearInterval(timer);
    }
  }, [isVisible]);

  return (
    <footer className="footer" ref={footerRef}>
      <div className="footer-container">
        <div className="logo-container">
          {/* Use the imported logo in an img tag */}
          <img src={degchiLogo} alt="Degchi Logo" className="logo-img" />
          <h1 className="logo-text"></h1>
        </div>
        <p className="footer-description">{typedDescription}</p>
        <div className="footer-button-container">
          <a href="#plans" className="footer-button">
            Subscribe Now
          </a>
        </div>
        <p className="copyright-text">&copy; 2025 Degchi Homemade Meals. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;

